export var isEntityAnUser = function (e) {
    return e.username && e.username.length > 0;
};
export var toEntityDisplayName = function (e, fullName) {
    if (isEntityAnUser(e)) {
        return fullName
            ? e.displayName + " " + e.username
            : e.displayName;
    }
    else {
        return e.displayName;
    }
};
export var toDistinguishedName = function (e) {
    var user = e;
    var group = e;
    return isEntityAnUser(e)
        ? user.userMetadata
            ? user.userMetadata.distinguishedName
            : undefined
        : group.groupMetadata
            ? group.groupMetadata.distinguishedName
            : undefined;
};
export var toEntityUniqueId = function (e) { return e.providerIdentifier; };
